import "./return-policy-page.css";
import { useNavigate } from "react-router-dom";
import adjara from "../../components/image/adjara2.png";
import { IoIosArrowBack } from "react-icons/io";

export const ReturnPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div class="return-policy">
      <button className="back-button" onClick={() => navigate(-1)}>
        <IoIosArrowBack size={"25px"} /> Назад
      </button>
      <h1>Правила возврата товара</h1>

      <section>
        <h2>1. Возврат товара, купленного онлайн</h2>
        <p>
          Согласно Закону Грузии «О защите прав потребителей», при покупке
          товара дистанционно (онлайн) потребитель имеет право отказаться от
          товара без указания причины и вернуть товар продавцу в течение 14 дней
          с момента получения товара.
        </p>
        <p>
          Если вы хотите отменить онлайн-заказ, пожалуйста, напишите на
          электронную почту:
          <a href="mailto:adjarapeak@gmail.com">adjarapeak@gmail.com</a>.
          Укажите в письме причину отмены и данные вашего заказа.
        </p>
        <p>
          <strong>Важно:</strong> возвращаемый товар должен сохранять товарный
          вид, содержать все комплектующие аксессуары, а также упаковку (если
          она была предусмотрена).
        </p>
        <ul>
          <li>
            Условие возврата не распространяется на товары стоимостью менее 30
            лари.
          </li>
        </ul>
        <p>
          <strong>Случаи, когда возврат невозможен:</strong>
        </p>
        <ul>
          <li>
            Нарушена герметичная упаковка (гигиенические и медицинские причины).
          </li>
          <li>
            Товар использовался, утрачен товарный вид или удалена маркировка.
          </li>
        </ul>
        <p>
          Потребитель обязан вернуть товар продавцу в течение 7 календарных дней
          после уведомления об согласовании возврата.
        </p>
        <p>
          Товар можно вернуть по адресу:{" "}
          <strong>Батуми, ул. Ген. Аслана Абашидзе, 19</strong> ежедневно с
          11:00 до 20:00.
        </p>
      </section>

      <section>
        <h2>2. Возврат товара, приобретенного в магазине</h2>
        <p>
          Если покупка совершена в магазине, возврат возможен только в случае
          брака или несоответствия.
        </p>
        <p>Право на возврат действует 14 дней с момента получения.</p>
        <p>
          Товар можно вернуть по адресу:{" "}
          <strong>Батуми, ул. Ген. Аслана Абашидзе, 19</strong> ежедневно с
          11:00 до 20:00.
        </p>
        <p>
          Если есть изменения в комплектующих или документах, возврат
          приостанавливается до проверки (до 14 рабочих дней).
        </p>
        <p>
          Необходим полный комплект документов: накладная, чек, гарантийный
          талон, упаковка и др.
        </p>
        <p>После 14 дней — по гарантии (если применимо).</p>
        <p>
          Возврат невозможен, если товар подпадает под ограничения
          законодательства (гигиенические товары, товары до 30 лари и пр.).
        </p>
      </section>

      <section>
        <h2>3. Порядок возврата денежных средств</h2>
        <p>
          Компания возвращает деньги в течение 14 дней после подтверждения
          возврата.
        </p>
        <p>Если товар требует проверки — до 7 дней после заключения сервиса.</p>
        <p>
          Деньги возвращаются тем же способом, которым была произведена оплата.
        </p>
        <p>
          Компания свяжется с вами после оценки состояния возвращённого товара
          для уточнения суммы возврата. Оценку может проводить как сама
          компания, так и сервисный центр.
        </p>
      </section>

      <p class="note">ПРАВИЛА НЕ РАСПРОСТРАНЯЮТСЯ НА ПРОКАТ СНАРЯЖЕНИЯ.</p>
    </div>
  );
};
